/**
 * 查询数据为空 显示组件
 */
export default {
  dbl_no_data_title: "查询数据为空，常见原因如下：",
  dbl_no_data_one: "1. 数据【过滤条件】矛盾；",
  dbl_no_data_two: "2. 数据量过大且未选择【分类维度】导致查询失败；",
  dbl_no_data_three: "3. 若仍然出现数据问题，请联系@v_blljli。",
	
};